<template>
  <div class="setting_wrapper">
    <div class="ignoreText">*点击屏蔽，在系统中将不再展示该指标或叶子结点</div>
    <el-table
      empty-text="暂无数据,敬请期待。"
      v-loading="loading"
      element-loading-text="加载中..."
      :data="render_list"
      row-key="node_id"
      border
      :default-expand-all="true"
      :tree-props="{ children: 'child' }"
    >
      <el-table-column
        label="评测项"
        label-class-name="tableHeader"
        show-overflow-tooltip="true"
      >
        <template #default="scope">
          <span
            class="level_tag"
            v-if="
              scope.row.is_leaf == 0 &&
              scope.row.level > 0 &&
              scope.row.level < 4
            "
            :style="{
              background: ['#649FEB', '#65C57C', '#F29D65'][
                scope.row.level - 1
              ],
            }"
          >
            {{
              ["一", "二", "三", "四", "五", "六"][scope.row.level - 1] +
              "级评测项"
            }}
          </span>
          <span>
            {{ scope.row.node_name || scope.row.name }}
          </span>
          <!-- <span class="tip_icon">

              </span> -->
        </template>
      </el-table-column>
      <el-table-column
        label="屏蔽后分数/总分数"
        show-overflow-tooltip="true"
        label-class-name="tableHeader"
        class-name="centerColumn"
        :width="200"
      >
        <template #default="scope">
          {{ scope.row.show_score + "/" + scope.row.total_score }}
        </template>
      </el-table-column>
      <el-table-column
        label="编辑"
        show-overflow-tooltip="true"
        label-class-name="tableHeader"
        class-name="centerColumn"
        :width="200"
      >
        <template #default="scope">
          <span
            class="recovery"
            v-if="exclude_nodes[scope.row.node_id]"
            @click="recoveryNode(scope.row)"
            >恢复</span
          >
          <span class="ignore" v-else @click="ignoreNode(scope.row)">屏蔽</span>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { ElTable, ElTableColumn, ElMessage, ElMessageBox } from "element-plus";
import { ref } from "vue";
import { getUserTreeData, addExcludeNodes, delExcludeNodes } from "@/api";
import store from "@/store";
export default {
  components: {
    ElTable,
    ElTableColumn,
  },
  setup() {
    const render_list = ref([]);
    let exclude_nodes = ref({});
    const loading = ref(false);
    let childMap = ref({});
    //增加level，total_score，show_score，根据子节点反推父节点状态
    const treeDataProcess = (treeList, level) => {
      let total_score = 0,
        show_score = 0,
        isIgnore = 0; //屏蔽数量
      treeList.forEach(function (item) {
        item.level = level;
        item.show_score = 0;
        if (item.child) {
          let child = treeDataProcess(item.child, level + 1);
          if (child.isIgnore == Object.keys(child.child).length) {
            exclude_nodes.value[item.node_id] = true;
            isIgnore++;
          }
          item.child = child.child;
          if (!item.total_score) {
            item.total_score = 0;
          }
          total_score += child.total_score;
          show_score += child.show_score;
          item.total_score = child.total_score;
          item.show_score = child.show_score;
        } else {
          if (exclude_nodes.value[item.node_id]) {
            isIgnore++;
          }
          total_score += item.item.total_score;
          item.total_score = item.item.total_score;
          if (!exclude_nodes.value[item.node_id]) {
            show_score += item.item.total_score;
            item.show_score = item.item.total_score;
          }
        }
      });
      return {
        child: treeList,
        total_score: total_score,
        show_score: show_score,
        isIgnore,
      };
    };

    const parseMapExclude = (excludeNodes) => {
      for (let i in excludeNodes) {
        exclude_nodes.value[excludeNodes[i]] = true;
      }
    };

    const getListData = (showLoading = true) => {
      loading.value = showLoading;
      getUserTreeData({car_type:2}).then((res) => {
        exclude_nodes.value = {};
        childMap.value = {};
        parseMapExclude(res.data.exclude_nodes);
        render_list.value = treeDataProcess(res.data.tree_list, 1).child;
        loading.value = false;
      });
    };

    getListData();

    //获取当前节点下所有子节点
    const getSyncNode = (node,type) => {
      let childNodeId = [];
      if(type == 'add'){
        if (!node.child && !exclude_nodes.value[node.node_id]) {
          return JSON.parse(JSON.stringify([node.node_id]));
        }
        node.child.forEach(function (cnode) {
          if (!cnode.child) {
            if(!exclude_nodes.value[cnode.node_id]){
              childNodeId.push(cnode.node_id);
            }
          } else {
            childNodeId = childNodeId.concat(getSyncNode(cnode,'add'));
          }
        });
      }else{
        if (!node.child && exclude_nodes.value[node.node_id]) {
          return JSON.parse(JSON.stringify([node.node_id]));
        }
        node.child.forEach(function (cnode) {
          if (!cnode.child) {
            if(exclude_nodes.value[cnode.node_id]){
              childNodeId.push(cnode.node_id);
            }
          } else {
            childNodeId = childNodeId.concat(getSyncNode(cnode,'del'));
          }
        });
      }
      console.log(childNodeId)
      return childNodeId;
    };

    const recoveryNode = (node) => {
      delExcludeNodes({ 
        review_tree_id: getSyncNode(node,'del'),
        car_type:2
      }).then((res) => {
        if (res.code == 200) {
          store.checkLeafHide('js',store.state.has_intelligent_hide - getSyncNode(node,'del').length)
          ElMessage.success("操作成功!");
          getListData(false);
        }
      });
    };

    const ignoreNode = (node) => {
       

      ElMessageBox.confirm(
        '<div style="font-size:13px;">屏蔽当前节点后：<br>\
1. 系统统计时不再显示该节点及子节点，并按0分进行合并计算;</div>\
',
        "温馨提示",
        {
          dangerouslyUseHTMLString: true,
          distinguishCancelAndClose: true,
          confirmButtonText: "确定屏蔽",
          cancelButtonText: "取消屏蔽",
        }
      )
        .then(() => {
          addExcludeNodes({ review_tree_id: getSyncNode(node,'add'),car_type:2}).then((res) => {
            if (res.code == 200) {
              store.checkLeafHide('js',store.state.has_intelligent_hide*1 + getSyncNode(node,'add').length)
              ElMessage.success("操作成功!");
              getListData(false);
            }
          });
        })
        .catch((action) => {
          console.log(action);
        });
    };

    return {
      loading,
      render_list,
      exclude_nodes,
      recoveryNode,
      ignoreNode,
      childMap,
    };
  },
};
</script>
<style scoped>
.setting_wrapper{
  width: 1000px;
}
.level_tag {
  display: inline-block;
  width: 83px;
  height: 18px;
  border-radius: 9px;
  text-align: center;
  font-size: 12px;
  color: #ffffff;
  line-height: 18px;
  margin: 0 10px;
}
.ignoreText {
  height: 24px;
  font-size: 12px;
  color: #8284a6;
  line-height: 24px;
  margin-bottom: 15px;
}
:deep(.tableHeader) {
  height: 24px;
  font-size: 16px;
  font-weight: bold;
  color: #474747;
  line-height: 24px;
  text-align: center;
}
.tip_icon {
  display: inline-block;
  width: 20px;
  height: 20px;
  background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/common/c33656821a1100392efd965678caf39d.png)
    no-repeat center bottom;
  background-size: 17px 17px;
  margin-left: 10px;
}
:deep(.centerColumn) {
  text-align: center;
  height: 21px;
  font-size: 16px;
  color: #474747;
  line-height: 21px;
}
.recovery {
  cursor: pointer;
  height: 21px;
  font-size: 16px;
  color: #909090;
  line-height: 21px;
  text-decoration: underline;
}
.ignore {
  height: 21px;
  font-size: 16px;
  color: #709ae8;
  line-height: 21px;
  text-decoration: underline;
  cursor: pointer;
}
:deep(.el-table thead .tableHeader){
  background: #f5f8fc;
}
</style>